export default __webpack_public_path__ + "static/media/holaluz.4198c792.svg";